import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { fetchMenuDetails } from '../../app/menudetails/menudetailSlice';
import { base_url, image_url } from '../../Utils/baseUrl';
import { MENU_IMAGE_PATH } from '../../Utils/baseUrl';
import { stripHtml, truncate } from '../../Utils/html';
import Loader from '../Common/Loader';
import { useContentLoader } from '../../Utils/useContentLoader';
import Seo from '../../Seo/Seo';
import { webPageSchema, menuItemSchema } from '../../Seo/jsonld';
import { fetchMenu } from '../../app/menu/menuSlice';
import Recommendeddish from '../RecommendedDish/recommendeddish';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import axios from 'axios';
import { config } from '../../Utils/axiosconfig'

function MenuDetails() {
  const pageNumber = 1;
  const pageSize = 15;

  const [child, setChild] = React.useState('');
  const [childlist, setChildlist] = useState('');

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 300,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const { idMenu } = useParams();
  const dispatch = useDispatch();
  const menuDetails = useSelector((state) => state.menuDetails);

  const user = useSelector((state) => state.user); // Getting the User Data.

  useEffect(() => {
    dispatch(fetchMenuDetails(idMenu));
    window.scrollTo(0, 0)
  }, [idMenu, dispatch]);

  useEffect(() => {
    dispatch(fetchMenu());
  }, [dispatch]);

  const [open, setOpen] = React.useState(false);

  const handleChange = (event) => {
    setChild(event.target.value);
    setOpen(false);
  };
  const handleOpen = () => {
    try {
      setOpen(true)
      axios.get(`${base_url}getChild?pageNumber=${pageNumber}&pageSize=${pageSize}`, config).then((res) => {
        setChildlist(res.data.data.child);

      }).catch((err) => {
        console.log(err);
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleClose = () => setOpen(false);

  // SEO values derived from the dish itself, so each of the ~250 dish pages
  // gets a genuinely unique title, description and image.
  const dish = menuDetails?.menuDetails?.data;
  const dishTitle = stripHtml(dish?.title);
  const dishDescription = stripHtml(dish?.description);
  const categoryTitle = stripHtml(dish?.Category?.title);
  const dishImage = dish?.MenuImages?.[0]?.image
    ? `${image_url}${MENU_IMAGE_PATH}${dish.MenuImages[0].image}`
    : undefined;

  // This route is not prerendered, so it starts from the blank app shell —
  // show a spinner until the dish arrives rather than an empty layout.
  const showLoader = useContentLoader(!dish);

  const path = `/menuDetails/${idMenu}`;

  const seoTitle = dishTitle
    ? `${dishTitle}${categoryTitle ? ` – ${categoryTitle}` : ""} | Onlineskolemad`
    : "Ret | Onlineskolemad";
  const seoDescription = dishDescription
    ? truncate(dishDescription)
    : truncate(
        `${dishTitle || "Denne ret"} er en del af vores skolemad. Se ingredienser og næringsindhold, og bestil nemt online til levering på skolen.`
      );

  if (showLoader) return <Loader />;

  return (
    <React.Fragment>
      <main>
        <Seo
          title={seoTitle}
          description={seoDescription}
          path={path}
          image={dishImage}
          type="article"
          // Readiness contract for the prerenderer: until the dish has loaded,
          // this page's title and description are generic fallbacks, so it
          // declares itself noindex. The prerenderer waits for an indexable
          // robots tag before snapshotting (see scripts/prerender/prerender.js),
          // which stops it capturing a page whose <h1> has filled in but whose
          // <title> is still the fallback.
          index={Boolean(dishTitle)}
          jsonLd={[
            webPageSchema({
              title: seoTitle,
              description: seoDescription,
              url: path,
              image: dishImage,
            }),
            menuItemSchema({
              name: dishTitle,
              description: dishDescription,
              image: dishImage,
              url: path,
            }),
          ]}
        />
        <section className="page-info-sec">
          <div
            className="bg-fixed wow fadeIn"
            data-wow-delay="0.1s"
            style={{ background: 'url("/assets/img/page-info1.png")' }}
          />
          <div className="bg-fixed img-overlay wow fadeIn" data-wow-delay="0.2s" />
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-12">
                <div className="page-info-block wow fadeInUp" data-wow-delay="0.3s">
                  {/* Was a hard-coded English "Food detail" heading followed by
                      Lorem ipsum. The hero now labels the dish's category and
                      the dish name stays the page's single <h1>, in the content
                      column where it has always been rendered. */}
                  <h2 className="page-info-h">{categoryTitle || "Ret"}</h2>
                  <div className="btm-line-2 text-center justify-content-center">
                    <span />
                    <span />
                  </div>
                  <p>
                    {categoryTitle
                      ? `${categoryTitle} – se ingredienser og næringsindhold, og bestil online til levering på skolen.`
                      : "Se ingredienser og næringsindhold, og bestil online til levering på skolen."}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="sec-pd rel-z-1">
          <div className="top-bottom-shaps">
            <span className="shap shap-1" />
            <span className="shap shap-2" />
          </div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 mmb-20">
                <div className="img-style-1 wow fadeInLeft">
                  {dishImage && (
                    <img src={dishImage} alt={dishTitle ? `${dishTitle} – skolemad fra Onlineskolemad` : 'Skolemad fra Onlineskolemad'} />
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <div
                    className="title-1 wow fadeInRight"
                    data-wow-delay="0.1s"
                    style={{
                      visibility: "visible",
                      animationDelay: "0.1s",
                      animationName: "fadeInUp"
                    }}
                  >
                    <h1>{dishTitle}</h1>
                    <div className="btm-line-1">
                      <span />
                      <span />
                    </div>
                    {user?.user?.status && (
                      <h3>Pris: {dish?.price} Kr</h3>
                    )}
                    {dishDescription && (
                      <div className="mb-20">
                        <h3>Beskrivelse</h3>
                        <p>{dishDescription}</p>
                      </div>
                    )}
                    {(dish?.IngredientCategories || []).length > 0 && (
                    <div className="mb-20">
                      <h3>Ingredienser</h3>

                      {(dish?.IngredientCategories || []).map((category, index) => (
                        <div key={index} style={{ marginBottom: "10px" }}>
                          
                          {/* Parent */}
                          <h4 style={{ fontWeight: "bold" }}>{category.title}</h4>
  
                          {/* Child */}
                          <ul>
                            {category.ingredients.map((ingredient, i) => (
                              <li key={i}>
                                {ingredient.title} 
                                {ingredient.price && ` (Extra: ${ingredient.price} Kr)`}
                              </li>
                            ))}
                          </ul>

                        </div>
                      ))}
                    </div>
                    )}
                    <div>
                      <h3>Næringsindhold pr. 100 g</h3>
                      <ul>
                        {dish?.nutrition && typeof dish.nutrition === 'object'
                          ? Object.keys(dish.nutrition).filter((key) => key !== 'nuti_desc').map((key, index) => (
                            <li key={index}>{key}: {dish.nutrition[key]}</li>
                          ))
                          : <p>Ingen næringsoplysninger tilgængelige.</p>
                        }
                        <li>
                          {dish?.nutrition?.nuti_desc && (
                            <>
                              <strong>Beskrivelse:</strong>
                              <div dangerouslySetInnerHTML={{ __html: dish.nutrition.nuti_desc }} />
                            </>
                          )}
                        </li>
                      </ul>
                    </div>
                    <div className="menu-desc">
                      <div className="menu-desc-head">
                        {user?.user?.status ? (
                          <Link className="btn btn-1" to={'/make-order'}>
                            Bestil nu
                          </Link>
                        ) : (
                          <Link className="btn btn-1" to={'/login'}>
                            Log ind for at bestille
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Select Child
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }} component="div">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Child List</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={child}
                    label="Child"
                    onChange={handleChange}
                  >
                    {(childlist !== undefined && childlist.length > 0) ?
                      childlist.map((item, index) => {
                        return (
                          <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                        )
                      }) :
                      <MenuItem>No child found</MenuItem>
                    }
                  </Select>
                </FormControl>
              </Typography>
            </Box>
          </Modal>
        </section>
        <Recommendeddish />
      </main>
    </React.Fragment>

  );
}

export default MenuDetails;
